const CUSTOM_ELEMENT_ID = "banner-logoanimation";

class BannerLogoanimation extends HTMLElement {

    constructor() {
        super();
        this.videos = null;
    }

    connectedCallback() {
        this.videos = this.querySelectorAll('.videoplayer');
        this.initVideoPlayback();
    }

    disconnectedCallback() {
        if (this.videos) {
            this.videos.forEach(video => {
                video.removeEventListener('ended', this.handleVideoEnded);
            });
        }
    }

    initVideoPlayback() {
        if (!this.videos || this.videos.length === 0) {
            return;
        }

        this.videos.forEach(video => {
            video.addEventListener('ended', this.handleVideoEnded.bind(this));

            const playPromise = video.play();
            if (playPromise !== undefined) {
                playPromise.catch(error => {
                    console.log('Video autoplay verhindert:', error);
                });
            }
        });
    }

    handleVideoEnded(event) {
        const video = event.target;
        video.pause();
    }
}

if (!customElements.get(CUSTOM_ELEMENT_ID)) {
    customElements.define(CUSTOM_ELEMENT_ID, BannerLogoanimation);
}
